export const currencyMask = (value) => {
  value = value.replace(".", "").replace(",", "").replace(/\D/g, "");

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat("pt-BR", options).format(
    parseFloat(value) / 100
  );

  return "R$ " + result;
};

export function formatNumberDecimalCoin(value, coin) {
  try {
    const valueNumber = Number(value);
    const locale = {
      countryCoin: coin === "pt" ? "pt-BR" : "en-US",
      currencyCoin: coin === "pt" ? "BRL" : "USD",
    };

    return valueNumber.toLocaleString(locale.countryCoin, {
      style: "decimal",
      currency: locale.currencyCoin,
    });
  } catch (error) {
    return 0;
  }
}
